import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Text from 'fe-design-base/atoms/Text';
import Alert from 'fe-design-base/molecules/Alert';
import PropTypes from 'prop-types';

import { toI18n } from 'util/i18n';

const BANNER_TYPE_TEAM = 'team';

const SsnValidationErrorBanner = ({ user, type = BANNER_TYPE_TEAM }) =>
  type === BANNER_TYPE_TEAM ? (
    <Alert variant="error">
      <Text color="mono900">
        {toI18n('team.employee_profile.ssn_validation_banner.team', {
          props: { first_name: user.get('first_name') },
        })}
      </Text>
    </Alert>
  ) : (
    <Alert variant="error">
      <Text color="mono900">
        {toI18n('team.employee_profile.ssn_validation_banner.drawer', {
          props: { first_name: user.get('first_name') },
        })}
      </Text>
    </Alert>
  );

SsnValidationErrorBanner.propTypes = {
  user: ImmutablePropTypes.map.isRequired,
  bannerType: PropTypes.string,
};

export default SsnValidationErrorBanner;
